import React, { useState, useCallback, useRef, useEffect } from 'react';
import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';
// import {} from "bootstrap-icons"
import { ArrowClockwise as ReloadIcon, FileEarmarkX as RemoveIcon } from "react-bootstrap-icons"
import { useRouteMatch } from 'react-router';
import { useTranslation } from 'react-i18next';
import { usePageContext } from '../contexts/ScanContext';
function generateDownload(canvas, crop, setImages, index) {
    if (!crop || !canvas) {
        return;
    }

    canvas.toBlob(
        (blob) => {
            setImages((blob))
    

        },
        'image/png',
        1
    );

}

export default function ImageCropper({ index, imageUrl, retry, remove, setImage }) {
    const [upImg, setUpImg] = useState(imageUrl.src);
    const imgRef = useRef(null);
    const previewCanvasRef = useRef(null);
    const [crop, setCrop] = useState({ unit: '%', width: 30, aspect: 16 / 9 });
    const [completedCrop, setCompletedCrop] = useState(null);
    const { t } = useTranslation();
    const onSelectFile = (e) => {
        if (e.target.files && e.target.files.length > 0) {
            const reader = new FileReader();
            reader.addEventListener('load', () => setUpImg(reader.result));
            reader.readAsDataURL(e.target.files[0]);
        }
    };

    useEffect(() => {
        setUpImg(imageUrl.src);
    })
    const onLoad = useCallback((img) => {
        imgRef.current = img;
    }, []);

    useEffect(() => {
        console.log(crop);
    }, [crop])
    useEffect(() => {
        if (!completedCrop || !previewCanvasRef.current || !imgRef.current) {
            return;
        }

        const image = imgRef.current;
        const canvas = previewCanvasRef.current;
        const crop = completedCrop;

        const scaleX = image.naturalWidth / image.width;
        const scaleY = image.naturalHeight / image.height;
        const ctx = canvas.getContext('2d');
        const pixelRatio = window.devicePixelRatio;

        canvas.width = crop.width * pixelRatio * scaleX;
        canvas.height = crop.height * pixelRatio * scaleY;

        ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
        ctx.imageSmoothingQuality = 'high';

        ctx.drawImage(
            image,
            crop.x * scaleX,
            crop.y * scaleY,
            crop.width * scaleX,
            crop.height * scaleY,
            0,
            0,
            crop.width * scaleX,
            crop.height * scaleY
        );

        const blob = generateDownload(previewCanvasRef.current, completedCrop, setImage);
        setImage(blob);
        
    }, [completedCrop]);

    return (
        <div >
            <ReactCrop
                src={upImg}
                onImageLoaded={onLoad}
                crop={crop}
                onChange={(c) => setCrop(c)}
                onComplete={(c) => setCompletedCrop(c)}
                className="cropImage"
            />
            <div style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                padding: "5px 15px 10px 15px"
            }}>
                <div style={{ flexGrow: "1" }}>
                    {t(imageUrl.lang)}
                </div>
                <ReloadIcon className="iconButton" onClick={retry}>retry</ReloadIcon>
                <RemoveIcon className="iconButton" onClick={remove}>remove</RemoveIcon>
            </div>
            <div
                className="canvas">
                <canvas
                    ref={previewCanvasRef}
                    // Rounding is important so the canvas width and height matches/is a multiple for sharpness.
                    style={{
                        width: Math.round(completedCrop?.width ?? 0),
                        height: Math.round(completedCrop?.height ?? 0)
                    }}
                />
            </div>


        </div>
    );
}
